/* Kochgeheimnis – Produktseite v2
   - "Jetzt kaufen": Cart-Permalink -> direkt zur Kasse, nur mit diesem Artikel (wie Shopifys "Direkt kaufen")
   - Bundle: Cart-Permalink mit allen 4 E-Books + Rabattcode -> direkt zur Kasse
   - Ehrlicher Countdown bis zu einem festen Datum (blendet sich danach aus)
   - Sticky Buy-Bar auf dem Handy, sobald der Kaufen-Block aus dem Bild scrollt */
(function () {
  'use strict';
  if (window.__kgProductInit) return;
  window.__kgProductInit = true;

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showError(el, msg) {
    if (!el) { window.alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function currentVariantId(btn) {
    var form = btn ? btn.closest('form') : null;
    if (form) { var inp = form.querySelector('input[name="id"]'); if (inp && inp.value) return inp.value; }
    if (btn && btn.dataset.variantId) return btn.dataset.variantId;
    var input = document.querySelector('form[data-type="add-to-cart-form"] input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : null;
  }

  /* Jetzt kaufen -> /cart/VARIANT:1 (Checkout nur mit diesem Artikel) */
  function buyNow(btn) {
    var variantId = currentVariantId(btn);
    var errorEl = document.querySelector('[data-kg-buynow-error]');
    if (!variantId) { showError(errorEl, 'Bitte lade die Seite neu und versuche es erneut.'); return; }
    setLoading(btn, true);
    window.location.href = ROOT + '/cart/' + encodeURIComponent(variantId) + ':1';
    setTimeout(function () { setLoading(btn, false); }, 8000);
  }

  /* Bundle -> /cart/ID:1,ID:1,... ?discount=CODE */
  function buyBundle(btn) {
    var box = btn.closest('[data-kg-bundle]');
    var errorEl = box ? box.querySelector('[data-kg-bundle-error]') : null;
    var ids = (btn.dataset.variantIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var code = (btn.dataset.discountCode || '').trim();
    if (!ids.length) { showError(errorEl, 'Das Sparpaket ist gerade nicht verfügbar.'); return; }
    setLoading(btn, true);
    var path = ROOT + '/cart/' + ids.map(function (id) { return encodeURIComponent(id) + ':1'; }).join(',');
    if (code) path += '?discount=' + encodeURIComponent(code);
    window.location.href = path;
    setTimeout(function () { setLoading(btn, false); }, 8000);
  }

  /* Countdown */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initDeadline(el) {
    var raw = el.dataset.kgDeadline || '';
    var end = /^\d+$/.test(raw) ? parseInt(raw, 10) * 1000 : Date.parse(raw);
    if (isNaN(end)) { el.hidden = true; return; }
    var d = el.querySelector('[data-kg-d]');
    var h = el.querySelector('[data-kg-h]');
    var m = el.querySelector('[data-kg-m]');
    var s = el.querySelector('[data-kg-s]');
    var t = null;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; if (t) clearInterval(t); return; }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (d) d.textContent = days;
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }
    tick();
    t = setInterval(tick, 1000);
  }

  /* Sticky Bar (Mobil) */
  function initSticky() {
    var bar = document.querySelector('[data-kg-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('.product-form__buttons') || document.querySelector('.product-form');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var visible = false;
    function setVisible(on) {
      if (on === visible) return;
      visible = on;
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('kg-sticky-active', on);
    }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var above = !e.isIntersecting && e.boundingClientRect.top < 0;
      setVisible(above);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }

  onReady(function () {
    document.addEventListener('click', function (ev) {
      var buy = ev.target.closest('[data-kg-buy-now]');
      if (buy) { ev.preventDefault(); buyNow(buy); return; }
      var bundle = ev.target.closest('[data-kg-bundle-buy]');
      if (bundle) { ev.preventDefault(); buyBundle(bundle); return; }
    });
    document.querySelectorAll('[data-kg-deadline]').forEach(initDeadline);
    initSticky();
  });
})();
